/**
 * The languages with a home: each written for its language, and alternates of each other. This module imports
 * nothing, so the Koa server (`server/index.ts`, compiled without the app's path aliases) can import it too.
 */
export const HOME_LANGS = ['en', 'fr', 'de', 'es', 'ja', 'zh'] as const
export type HomeLang = (typeof HOME_LANGS)[number]

/** The home an `Accept-Language` header asks for: its most preferred language that has one, English included. */
export function preferredHome(acceptLanguage: string): HomeLang | null {
    const ranked = acceptLanguage
        .split(',')
        .map((entry, order) => {
            const [tag, ...params] = entry.split(';').map((part) => part.trim())
            const q = params.find((p) => p.startsWith('q='))
            return {lang: tag.split('-')[0].toLowerCase(), weight: q ? Number(q.slice(2)) : 1, order}
        })
        .filter(({weight}) => weight > 0)
        .sort((a, b) => b.weight - a.weight || a.order - b.order)
    return ranked.map(({lang}) => lang).find((lang): lang is HomeLang => (HOME_LANGS as readonly string[]).includes(lang)) ?? null
}
